export enum UserType {
  admin = 'ADMIN',
  staff = 'STAFF',
  relative = 'RELATIVE',
  participant = 'PARTICIPANT',
  systemAdmin = 'SYSTEM_ADMIN',
}
